export const ordersES = {
  "There no individual spreadsheets to display": "There no individual spreadsheets to display",
  "New Spreadsheet": "New Spreadsheet",
  "Actions": "Actions",
  "Format Name": "Format Name",
  "Description": "Description",
  "Folder": "Folder",
  "Modified By": "Modified By",
  "Date Modified": "Date Modified",
  "Created By": "Created By",
  "Date Created": "Date Created",
  "Run Spreadsheet": "Run Spreadsheet",
  "Edit Spreadsheet": "Edit Spreadsheet",
  "Delete Spreadsheet": "Delete Spreadsheet",
  "Are you sure you want to delete the selected format?": "Are you sure you want to delete the selected format?",
  'Select Organization': 'Select Organization',
  "Organization's orders": "Organization's orders",
  'My Orders': 'My Orders',
  'All Organizations': 'All Organizations',
  'Failed to change organization': 'Failed to change organization',
  'Failed to load data': 'Failed to load data',
  'Name': 'Name',
  'Date': 'Date',
  'View': 'View',
  'Open Status Results': 'Open Status Results',
  'Close': 'Close',
  'Documents for': 'Documents for',
  'Close': 'Close',
  'Cancel': 'Cancel',
  'Save': 'Save',
  'Operation Canceled': 'Operation Canceled',
  'Pedigree sent': 'Pedigree sent',
  "Organization's orders": "Organization's orders",
  'My Orders': 'My Orders',
};